<script lang="ts">
  import {createEventDispatcher} from 'svelte';
  import {Icon} from '@components';

  export let imgSrc = '';
  export let loading = false;

  const dispatch = createEventDispatcher();
  const selectImage = async (e: any) => {
    dispatch('image-changed', {
      file: e.target.files[0]
    });
  };
</script>

<div>
  <label for="upload-image" class={imgSrc ? 'upload-image with-image' : 'upload-image no-image'}>
    {#if loading}
      <div class="flex h-20 w-full flex-col items-center justify-center">
        <Icon name="Spinner" className=" text-gray-400 w-8 h-8 animate-spin" />
        <div class="mt-2 block text-sm text-gray-500">Uploading Image...</div>
      </div>
    {:else if imgSrc}
      <div class="flex h-20 w-20 items-center justify-center">
        <img src={imgSrc} alt="" class="h-full w-full object-contain" />
      </div>
    {:else}
      <div class="flex h-20 w-full items-center justify-center">
        <div>+ Upload image</div>
      </div>
    {/if}
  </label>
  <input name="file" type="file" class="hidden" accept="image/*" id="upload-image" on:change={selectImage} />
</div>

<style lang="postcss">
  label.upload-image {
    @apply flex w-full items-center justify-center p-8;
    @apply rounded-lg border-2 border-gray-400 bg-white;
    @apply cursor-pointer transition-all duration-150 ease-linear;
  }

  label.upload-image:hover {
    @apply bg-gray-200;
  }

  label.no-image {
    @apply border-dashed border-gray-400 p-8 text-gray-400;
  }

  label.with-image {
    @apply border-gray-200 p-6 text-gray-200;
  }
</style>
